import {
  init,
  analyticsOptionsShow,
  analyticsOptionInteraction,
  analyticsCustom,
  optionsShowAllFromConfigurator,
  applyCPQSelections,
  runApplyCPQSelections,
  buildCpqSelectionsForApply,
  getCpqAttributeKeyFromDisplayAttribute,
  listCpqLinkedDisplayAttributes,
  listCpqLinkedDisplayAttributesFromConfigurator,
  registerCpqLinkedAttributeListeners,
  OptionsType,
  OptionInteractionType,
} from "./embed-api";
import { attachAnimationToggleDock } from "./animation-toggle-dock";
import { attachArLaunchDock } from "./ar-launch-dock";

export type {
  EmbedInitOptions,
  ThreekitEmbedHandle,
  ThreekitPlayerInitOptions,
  AnalyticsInitOptions,
  OptionsShowParams,
  OptionInteractionParams,
  CustomEventParams,
  OptionsShowAllFromConfiguratorOptions,
  ApplyCPQSelectionsOptions,
  ApplyCPQSelectionsResult,
  CpqLinkedDisplayAttribute,
  SnapshotAndUploadOptions,
  SnapshotAndUploadResult,
  ThreekitSnapshotAsyncOptions,
  RegisterCpqLinkedAttributeListenersOptions,
  CpqLinkedAttributeListenersHandle,
  CpqJsAttributeApi,
  ArQrCodeUploadOptions,
  ArQrCodeUploadResult,
} from "./embed-api";
export { threekitFilesApiUrl, threekitFileContentUrl } from "./embed-api";
export type {
  AnimationToggleDockOptions,
  AnimationToggleDockHandle,
} from "./animation-toggle-dock";
export type { ArLaunchDockOptions, ArLaunchDockHandle } from "./ar-launch-dock";

/**
 * Low-level Threekit + analytics API. `ThreekitCpqApp` (see `app/embed-global.ts`) wraps this
 * for standalone and IIFE embed use; credentials live in that app layer / `mount()` options.
 */
const ThreekitEmbed = {
  init,
  attachAnimationToggleDock,
  attachArLaunchDock,
  analyticsOptionsShow,
  analyticsOptionInteraction,
  analyticsCustom,
  optionsShowAllFromConfigurator,
  applyCPQSelections,
  runApplyCPQSelections,
  buildCpqSelectionsForApply,
  getCpqAttributeKeyFromDisplayAttribute,
  listCpqLinkedDisplayAttributes,
  listCpqLinkedDisplayAttributesFromConfigurator,
  registerCpqLinkedAttributeListeners,
  OptionsType,
  OptionInteractionType,
};

export default ThreekitEmbed;
